<template>
  <div
    class="feature-block"
    :style="{
      background: info.background,
    }"
    @mouseenter="isActive = true"
    @mouseleave="isActive = false"
  >
    <div class="icon-wrap l-center">
      <img :src="info.icon" />
    </div>
    <div class="l-center">
      <div class="subTitle" :style="{ color: info.themColor }">
        {{ info.subTitle }}
      </div>
    </div>
    <div class="title">{{ info.title }}</div>
    <div class="description">
      {{ info.description }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
};
</script>
<style lang="less" scoped>
.feature-block {
  &:hover {
    transform: scale(1.1);
    filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.1));
  }
  transition: all 0.3s;
  width: 250px;
  height: 280px;
  position: relative;
  border-radius: 8px;
  padding: 15px;
  padding-top: 50px;
  .icon-wrap {
    width: 70px;
    height: 70px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border: 1px solid #e8e8e8;
  }
  .subTitle {
    padding: 10px 20px;
    font-size: 12px;
    background-color: #fff;
    border-radius: 20px;
  }
  .title {
    margin-top: 20px;
    font-weight: bold;
    font-size: 25px;
  }
  .description {
    margin-top: 20px;
    color: #414b59;
    line-height: 25px;
    font-size: 16px;
  }
}
</style>
